import { render, staticRenderFns } from "./UploadDropCard.vue?vue&type=template&id=e33893b6&scoped=true&"
import script from "./UploadDropCard.vue?vue&type=script&lang=js&"
export * from "./UploadDropCard.vue?vue&type=script&lang=js&"
import style0 from "./UploadDropCard.vue?vue&type=style&index=0&id=e33893b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33893b6",
  null
  
)

export default component.exports